import {
  type ExtensionProps,
  type NodeConfig,
  type RicosExtension,
  type RicosServices,
} from 'ricos-types';

import { createRicosNodeExtension } from './create-ricos-extension';
import { liftEmptyOrderedListItem } from './lift-empty-ordered-list-item';

export const keymap = createRicosNodeExtension({
  name: 'ricos-keymap',
  groups: ['shortcuts-enabled'],
  type: 'html-node',
  reconfigure: (
    config: NodeConfig,
    _extensions: RicosExtension[],
    _props: ExtensionProps,
    settings: Record<string, unknown>,
    services: RicosServices
  ) => {
    return {
      ...config,
      addOptions() {
        return {
          services,
          HTMLAttributes: {},
          ...settings,
        };
      },
    };
  },

  createExtensionConfig() {
    return {
      name: this.name,
      inline: true,
      group: 'inline',
      priority: 100,

      selectable: false,

      addKeyboardShortcuts() {
        const newLine = () => {
          return this.editor.commands.first(({ commands }) => [
            () => commands.newlineInCode(),
            () => commands.createParagraphNear(),
            ({ state, dispatch }) => liftEmptyOrderedListItem(state, dispatch),
            () => commands.liftEmptyBlock(),
            () => commands.splitBlock(),
          ]);
        };

        const tiptapKeyboardShortcuts: any = {
          Enter: newLine,
        };

        const newLineShortcuts: any = [];
        // Might be a dead code since none of the shortcuts has a 'NewLine' name
        this.options.services.shortcuts.shortcuts.forEach(shortcut => {
          if (shortcut.shortcut.name === 'NewLine') {
            newLineShortcuts.push(shortcut);
          }
        });

        newLineShortcuts.forEach(newLineShortcut => {
          const modifier = newLineShortcut.keys.macOs.modifiers[0];
          const key = newLineShortcut.keys.macOs.key;
          const shortcutKey = modifier ? `${modifier}-${key}` : key;
          tiptapKeyboardShortcuts[shortcutKey] = newLine;
        });

        return {
          ...tiptapKeyboardShortcuts,
        };
      },
    };
  },
});
